import type { ReactNode } from "react";

import BrandLogo from "components/brand/BrandLogo";

interface AuthFormLayoutProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

const AuthFormLayout = ({ title, subtitle, children }: AuthFormLayoutProps): JSX.Element => {
  return (
    <div className="mx-auto w-full max-w-[470px]">
      <div className="mb-5 flex justify-center">
        <BrandLogo size="lg" showWordmark={false} align="center" />
      </div>

      <div className="rounded-3xl border border-white/80 bg-white/95 p-7 shadow-xl shadow-slate-900/5 backdrop-blur dark:border-white/10 dark:bg-surface/90 sm:p-8">
        <h1 className="mb-2 text-center text-4xl font-bold text-ink">
          {title}
        </h1>
        {subtitle ? (
          <p className="mb-8 text-center text-base leading-7 text-ink-muted">
            {subtitle}
          </p>
        ) : null}

        {children}
      </div>
    </div>
  );
};

export default AuthFormLayout;